// extracted by css-extract-rspack-plugin
export default {"wrapper":"pagination__wrapper___qkUEP","rotate180":"pagination__rotate180___xCWfR"};